<script lang="ts">
	import type { CmsFooterRecord } from '$lib/data/types';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { isExternal } from '$lib/links';
	import { locale } from 'svelte-i18n';
	import { localizeUrl } from '$lib/i18n';

	export let columns: CmsFooterRecord['columns'];
</script>

<nav>
	{#each columns as col}
		{@const translation = getCmsTranslationForLocale(col.translations, $locale)}
		<section>
			<h5>{translation.title}</h5>

			{#if translation.pre_text}
				{@html translation.pre_text}
			{/if}

			{#if col.links}
				<ul>
					{#each col.links as link}
						{@const translation = getCmsTranslationForLocale(link.translations, $locale)}
						<li>
							<a
								href={localizeUrl(link.url, $locale)}
								target={isExternal(link.url) ? '_blank' : null}
								rel={isExternal(link.url) ? 'external' : null}
								class:external={isExternal(link.url)}
							>
								{translation.title}
							</a>
						</li>
					{/each}
				</ul>
			{/if}
		</section>
	{/each}
</nav>

<style>
	nav {
		word-wrap: break-word;

		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
		gap: 4rem;
		padding: 2rem;
	}

	section {
		flex-grow: 1;
	}

	h5 {
		text-transform: uppercase;
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	li {
		margin: 0;
		padding: 0.25rem 0;
	}

	a {
		color: #ffffff;
	}
</style>
